import React, { useEffect, useState } from "react";
import { Image as KonvaImage, Rect, Text } from "react-konva";
import { useTranslation } from "react-i18next";
import { TrackTraceFloorMap } from "../../trackTrace/types";

interface Props {
    floorMap: TrackTraceFloorMap;
    onLoadError: () => void;
}

const FloorPlanImageLayer: React.FC<Props> = ({ floorMap, onLoadError }) => {
    const { i18n } = useTranslation();
    const t = (key: string, options?: object) => (i18n.t as unknown as (key: string, options?: object) => string)(key, options);
    const [image, setImage] = useState<HTMLImageElement | null>(null);

    useEffect(() => {
        if (!floorMap.image_url) return;
        const img = new window.Image();
        img.onload = () => setImage(img);
        img.onerror = onLoadError;
        img.src = floorMap.image_url;
    }, [floorMap.image_url, onLoadError]);

    if (image) {
        return <KonvaImage image={image} width={floorMap.image_width || image.width} height={floorMap.image_height || image.height} />;
    }

    return (
        <>
            <Rect width={floorMap.image_width || 800} height={floorMap.image_height || 600} fill="#f8fafc" stroke="#cbd5e1" />
            <Text x={24} y={24} text={t('track_trace.map.loading_floor_plan')} fill="#64748b" fontSize={18} />
        </>
    );
};

export default FloorPlanImageLayer;
